<template>
    <div>
      <div class="row mb-2">
        <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
          <div class="carousel-inner">
              <div class="carousel-item" v-for="(photo, index) in photos"  :class="{ 'active': index==0 }" :key="index" >
                <img class="d-block w-100" :src="`${storagePath()}/${photo.path}`" alt="">
              </div>
          </div>
          <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
      </div>
      <div class="row justify-content-center">
          <b-btn v-b-modal.uploadphoto variant="primary">
            Загрузить фото
          </b-btn>
      </div>
      <b-modal
        id="uploadphoto"
        size="lg"
        title="Загрузка фото"
        ref="modalUploadPhone"
        :ok-title="$t('buttons.ok')"
        :cancel-title="$t('buttons.cancel')"
        @ok="fileInputSubmit"
        @shown="clearPhotoModal"
      >
          <input
            type="file"
            name="image"
            multiple
            @change="fileInputChange"
            id="imgs"
            ref="files"
            class="form-control"
            :class="{'is-invalid': errors.image }"
          >
          <span v-if="errors.image" class="invalid-feedback">
              <strong>{{ errors.image ? errors.image[0] : '' }}</strong>
          </span>
          <div class="row mb-2" v-if="fileProgress">
            <div class="col-md-12">
              <div class="progress" style="height: 30px">
                <div
                  class="progress-bar progress-bar-striped bg-success"
                  role="progressbar"
                  :style="{width: fileProgress + '%'}"
                  :aria-valuenow="fileProgress"
                  aria-valuemin="0"
                  aria-valuemax="100"
                >
                  {{fileCurrent}}
                </div>
              </div>
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="col-md-6 col-sm-12 mt-2" v-for="(img, index) in previewImgs" :key="index">
              <img alt="image" :src="img" class="card-img" />
            </div>
          </div>
      </b-modal>
    </div>
</template>

<script>
export default {
  props: [
    'debtorIin',
  ],
  data() {
    return {
      imgs: [],
      photos: [],
      previewImgs: [],
      isProcessing: false,
      fileProgress: '',
      fileCurrent: '',
      errors: {},
    };
  },
  mounted() {
    this.getPhotos();
  },
  methods: {
    getPhotos() {
      this.isProcessing = true;
      window.axios.get(`/debtor/${this.debtorIin}/photos`)
        .then((res) => {
          this.photos = res.data.photos;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    clearPhotoModal() {
      this.previewImgs = [];
      this.$refs.files.value = '';
    },

    async fileInputChange() {
      const files = Array.from(event.target.files);
      for (const item of files) {
        await this.priviewImg(item);
      }
    },

    async fileInputSubmit(evt) {
      evt.preventDefault();
      const files = this.imgs;
      for (const item of files) {
        await this.uploadFile(item);
      }
    },

    async priviewImg(item) {
      const url = URL.createObjectURL(item);
      this.imgs.push(item);
      this.previewImgs.push(url);
    },

    async uploadFile(item) {
      const form = new FormData();
      form.append('image', item);

      await window.axios.post(`/debtor/${this.debtorIin}/photos`, form, {
        onUploadProgress: (itemUpload) => {
          this.fileProgress = Math.round((itemUpload.loaded / itemUpload.total) * 100);
          this.fileCurrent = `${item.name} ${this.fileProgress}%`;
        },
      })
        .then((res) => {
          if (res.data.success) {
            this.fileProgress = 0;
            this.fileCurrent = '';
            this.clearPhotoModal();
            this.getPhotos();
          }
        })
        .catch((err) => {
          this.errors = {};
          this.fileProgress = '';
          this.previewImgs = [];
          if (err.response) {
            if (err.response.status === 500) {
              window.Swal.fire('Упс', 'Что-то пошло не так!', 'error');
            } else if (err.response.status === 422) {
              this.errors = err.response.data.errors;
            }
          }
        });
    },
  },
};
</script>
